import React from 'react'
import { Aircraft } from '../../../types/intellijetnet'

interface SerialNumberCellProps {
  aircraft: Aircraft
  cellBorderClass: string
  isEditMode?: boolean
  isOffMarket: boolean
  isTemporary: boolean
  handleNavigate: () => void
}

/**
 * Renders the S/N column cell: serial number, registration, aircraft ID,
 * and off-market/moved badges. In edit mode, clicking navigates to detail.
 */
export function SerialNumberCell(props: SerialNumberCellProps) {
  const { aircraft, cellBorderClass, isEditMode, isOffMarket, isTemporary, handleNavigate } = props

  return (
    <td
      className={`px-2 py-2 text-sm text-center ${cellBorderClass} ${isEditMode ? 'cursor-pointer hover:bg-gray-100' : ''}`}
      onClick={isEditMode ? (e) => { e.stopPropagation(); handleNavigate(); } : undefined}
    >
      <div className="font-medium text-gray-900">{aircraft.sernbr}</div>
      <div className="text-gray-500">{aircraft.regnbr}</div>
      <div className="text-gray-400 text-xs">ID: {aircraft.aircraft_id}</div>
      {isOffMarket && <div className="text-green-700 text-xs font-medium">Off-Mkt</div>}
      {isTemporary && <div className="text-blue-700 text-xs font-medium">Moved</div>}
    </td>
  )
}

